import React from 'react';
import { addRecentRun, loadRecentRuns, removeRecentRun, saveRecentRuns, toRecentRun } from './runHistory';

// Owns the recent-run list and its persistence. Reads storage once, in the initializer rather than
// an effect, so the list is there on the first paint instead of appearing a moment later.
export const useRecentRuns = () => {
  const [runs, setRuns] = React.useState(() => loadRecentRuns());

  const record = React.useCallback((params, result) => {
    if (!params?.feedId || !result) return;
    // Sample data isn't a run worth recalling.
    if (result.isMock) return;

    setRuns((prev) => {
      const next = addRecentRun(prev, toRecentRun({ params, result, ranAt: new Date() }));
      saveRecentRuns(next);
      return next;
    });
  }, []);

  const remove = React.useCallback((run) => {
    if (!run) return;
    setRuns((prev) => {
      const next = removeRecentRun(prev, run);
      saveRecentRuns(next);
      return next;
    });
  }, []);

  const clear = React.useCallback(() => {
    setRuns([]);
    saveRecentRuns([]);
  }, []);

  return { runs, record, remove, clear };
};
